import ptPlusApiBaseUrl from '../../../api/ptPlusApiBaseUrl';
import { showAppLoader, hideAppLoader } from '../app';


export const ptPlusPaymentAdjumentRequestSend = (data) => (dispatch) => {
  const token = localStorage.getItem("token")

  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/resolution/payment_adjustments`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusPaymentAdjumentInvoices = (data) => (dispatch) => {
  const token = localStorage.getItem("token")

  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`ptms/resolution/adj_invoice_list`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const ptPlusPaymentAdjumentInvoiceDownload = (invoiceId) => (dispatch) => {
  const token = localStorage.getItem("token")
  return ptPlusApiBaseUrl.get("ptms/s3/get_file/" + invoiceId + ".pdf",
    {
      headers: {
        Authorization: `${token}`,
        UserType: "internal",
      },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const adjustmentInvoiceStausUpdateApiFunc = (data) => (dispatch) => {
  const token = localStorage.getItem("token")
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl
    .post(`ptms/resolution/adj_inv/update_status`, data, {
      headers: {
        Authorization: `${token}`,
        UserType: "internal",
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};